import React from 'react'

const ToggleButton = ({ onChange, checked, isDisabled = false, customClass = '' }) => {
  const handleChange = () => {
    onChange(!checked)
  }
  return (
    <label className={`toggle-switch ${customClass}`}>
      <input type="checkbox" onChange={handleChange} checked={checked || false} disabled={isDisabled} />
      <span className="slider round"></span>
    </label>
  )
}
export default ToggleButton